/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/no-unknown-property */
/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-shadow */

import React, { useEffect, useState, useRef, Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material/';

import { Canvas, ThreeEvent } from '@react-three/fiber';
import { OrbitControls, Grid, Bounds, useBounds } from '@react-three/drei';
import * as THREE from "three";
import  URDFLoader ,{URDFRobot, URDFJoint} from 'urdf-loader';
// import { ColladaLoader } from 'three/examples/jsm/loaders/ColladaLoader.js';

import useNotification from "../utils/notificationUtil";
import Pjdb1ToolTip from "./inputs/Pjdb1ToolTip";

let isPackageUrdf = false;

interface ReadUrdfProps {
  urdfUrl:string|undefined;
  mesheUrls?:string[]|undefined;
  onLoadUrdf?: (robot: URDFRobot) => void;
  pointerDown?: (event: ThreeEvent<PointerEvent>) => void;
}
function URDFModel(props: ReadUrdfProps) {
  const { errorMsg } = useNotification();
  const [robot, setRobot] = useState<URDFRobot>();
  const modelRef = useRef<THREE.Group>(new THREE.Group());

  const bounds = useBounds()
  let manager = new THREE.LoadingManager();

  const adjustModel =()=>{
    if(modelRef.current.children.length > 0){
      // const robotModel:URDFRobot = modelRef.current.children[0];
      const robotModel:URDFRobot = (modelRef.current.children[0] as URDFRobot);
      const box = new THREE.Box3().setFromObject(robotModel);
      const size = new THREE.Vector3();
      box.getSize(size);
      const center = new THREE.Vector3();
      box.getCenter(center);

      // modelを中心にずらす
      modelRef.current.position.set(center.x * -1, center.y * -1, center.z * -1);

      bounds.refresh().clip().fit();
      if(props.onLoadUrdf){
        props.onLoadUrdf(robotModel);
      }
    }
  }

  useEffect(() => {
    if(modelRef.current.children.length > 0 && !isPackageUrdf){
      // 関連ファイルなしのurdfはmanagerのonloadでは取得できないためこちらで処理
      adjustModel();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [robot]);
  async function readUrdfFileFromUrl(urdfUrl: string, mesheUrls: string[]) {
    manager = new THREE.LoadingManager();
    manager.onLoad = ()=>{
      if(modelRef.current.children.length > 0 && isPackageUrdf){
        // 関連ファイルありのurdfはmanagerのonload処理で取得して処理
        adjustModel();
      }
    };

    const LINK_FILE_REPLACE_PATH = "/meshes/";
    let urdfPath = "";

    if(!isPackageUrdf){
      // .daeなどの関連ファイルなし
      urdfPath = urdfUrl;
    }else{
      // .daeなどの関連ファイルあり

      // URLからデータを取得
      const response = await fetch(urdfUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch: ${response.statusText}`);
      }
      // テキストとして読み込む
      const urdfText = await response.text();
      // console.log("【prev】------------------------------\n", urdfText)
      // ファイル内容を修正
      let modUrdfText = urdfText;
      const meshMatches = modUrdfText.match(/<mesh .*>/i);
      if (meshMatches) {
        meshMatches.forEach((meshMatch) => {
          let meshTagTxt = meshMatch;

          const filePathMatches  = meshTagTxt.match(/filename="([^"]+)"/i);
          if (filePathMatches) {
            const filePath = filePathMatches[1];

            const fileNameMatches = filePath.match(/\/([^/]*)$/);
            if (fileNameMatches) {
              const fileName = fileNameMatches[1];

              // 固定のパスで置換（後続「setURLModifier」でcloudパスにアクセスさせる）
              meshTagTxt = meshTagTxt.replace(filePath,`package:/${LINK_FILE_REPLACE_PATH}${fileName}`);
              modUrdfText = modUrdfText.replace(meshMatch, meshTagTxt);
            }
          }

        });
      }
      // console.log("【after】------------------------------\n", modUrdfText);

      // 文字列をBlobに変換
      const blob = new Blob([modUrdfText], { type: "text/plain" });
      // BlobからオブジェクトURLを作成
      urdfPath = URL.createObjectURL(blob);

      // パス解釈処理
      manager.setURLModifier((url) => {
        // 関連ファイルパスのアクセス先をcloudパスに変換
        if(url.indexOf(LINK_FILE_REPLACE_PATH)!==-1){
          const fileNameMatches = url.match(/\/([^/]*)$/);
          if (fileNameMatches) {
            const fileName = fileNameMatches[1];
            const cloudPath = mesheUrls.find(url=>url.indexOf(fileName)!==-1);
            if(cloudPath){
              return cloudPath;
            }
          }
        }
        return url;
      });
    }
    // urdf-loaderで読込
    const loader = new URDFLoader(manager);
    loader.load(
      urdfPath, // URDFファイルのパス
      (robot) => {
        robot.traverse((child) => {
          if ((child as THREE.Mesh).isMesh) {
            const mesh = child as THREE.Mesh;
            mesh.castShadow = true;
            mesh.receiveShadow = true;
          }
        });
        setRobot(robot);
      },
      undefined,
      (error) => {
        errorMsg("モデルファイルの読込に失敗しました。");
        console.error("Error loading URDF:", error);
      }
    );
  }

  useEffect(() => {
    const urdfUrl = props.urdfUrl ? props.urdfUrl : "";
    const mesheUrls = props.mesheUrls ? props.mesheUrls : [];
    isPackageUrdf = mesheUrls.length > 0;
    if (urdfUrl) {
      // eslint-disable-next-line no-void
      void readUrdfFileFromUrl(urdfUrl, mesheUrls);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.urdfUrl, props.mesheUrls]);

  return !robot ? null :
    <group ref={modelRef}>
      <primitive object={robot} rotation={[-0.5 * Math.PI, 0, Math.PI]}
      onPointerDown={props.pointerDown}
      />
    </group>
  ;
}

let loadedRobotModel:URDFRobot;
interface Props {
  urdfUrl:string|undefined;
  mesheUrls?:string[]|undefined;
}
/**
 * URDFファイル表示
 * @author TAW j.sano
 * @param props
 * @returns
 */
export default React.memo((props: Props) => {
  const [isOnLoad, setIsOnLoad] = useState(false);
  const axesRef = useRef<THREE.AxesHelper>(null);
  const gridRef = useRef<THREE.Mesh>(null);
  const [gridArgs, setGridArgs] = useState<[number, number]>([2, 2]);

  const controlsRef = useRef<any>(null);

  const [isMouseInside, setIsMouseInside] = useState(true);

  let intersectedObject:THREE.Object3D|null = null;
  let selectedJoint:URDFJoint|null = null;
  let selectedJointColor = "";

  // 親をたどり、jointを探す
  const findJointFromObject = (object: THREE.Object3D): URDFJoint|null => {
    if (!loadedRobotModel) return null;
    let current: THREE.Object3D | null = object;
    while (current) {
      const joint = loadedRobotModel.joints[current.name];
      if (joint) return joint;
      current = current.parent;
    }
    return null;
  };
  // jointのクリック
  const handlePointerDown = (event: ThreeEvent<PointerEvent>) => {
    if(!selectedJoint){
      intersectedObject = event.object; // マウスが当たったオブジェクト
      const joint = findJointFromObject(intersectedObject);
      if (joint && joint.jointType!=="fixed") {
        selectedJoint = joint;
        const {material} = (intersectedObject as THREE.Mesh);
        if (material instanceof THREE.MeshStandardMaterial || material instanceof THREE.MeshPhongMaterial) {
          selectedJointColor = material.color.getStyle();
          material.color.set("rgb(124, 236, 124)"); // 色を変更
        }
      }
    }
  }
  // jointの選択解除
  const unSelectedJoint = () =>{
    if(selectedJoint){
      selectedJoint = null;
      if(intersectedObject){
        const {material} = (intersectedObject as THREE.Mesh);
        if (material instanceof THREE.MeshStandardMaterial || material instanceof THREE.MeshPhongMaterial) {
          material.color.set(selectedJointColor); // 色を戻す
        }
      }
    }
  }
  // クリック解除
  const handlePointerUp = () => {
    unSelectedJoint();
  };
  // 領域内にポインター移動
  const handlePointerEnter = () => {
    setIsMouseInside(true);
  };
  // 領域外にポインター移動
  const handlePointerLeave = () => {
    setIsMouseInside(false);
    unSelectedJoint();
  };

  // cameraの向き判断
  const cameraDirectionChecker = ():boolean =>{
    if (!controlsRef.current) return true;
    // OrbitControlsのターゲット（注視点）
    const {target} = controlsRef.current;
    // カメラの位置
    const cameraPosition = controlsRef.current.object.position;
    // カメラ方向ベクトル（カメラの位置からターゲットへのベクトル）
    const cameraDirection = new THREE.Vector3()
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      .subVectors(target, cameraPosition)
      .normalize();
    // 正面とみなす方向（ワールド座標の +Z 方向）
    const frontDirection = new THREE.Vector3(0, 0, 1);
    // 内積を計算してカメラが正面を向いているかをチェック
    const dot = cameraDirection.dot(frontDirection);
    return dot > 0;

  }
  // マウス移動（joint選択時は関節を動かす）
  const handlePointerMove = (event: any) => {
    if(!isMouseInside){
      event.stopPropagation();
      return;
    }
    if (selectedJoint) {
      // マウスの移動量
      let delta = 0;
      if(Math.abs(Number(event.movementY)) > Math.abs(Number(event.movementX))){
        delta = event.movementY * 0.01 * -1;
      }else{
        delta = event.movementX * 0.01;
        if(!cameraDirectionChecker()) delta *= -1; // 正面を向いていない場合は逆転
      }
      const currentAngle = Number(selectedJoint.jointValue) || 0;
      selectedJoint.setJointValue(currentAngle + delta); // 関節の角度を更新
      event.stopPropagation(); // cameraの視点移動は無効化
    }
  };

  // URDFファイル読込時処理
  const onLoadUrdf = (robotModel:URDFRobot)=>{
    loadedRobotModel = robotModel;

    const box = new THREE.Box3().setFromObject(robotModel);
    const size = new THREE.Vector3();
    box.getSize(size);

    // モデルを中心にずらした分の基点のポジション
    const basePoint:THREE.Vector3 = new THREE.Vector3(
      size.x / 2 * -1,
      size.y / 2 * -1,
      size.z / 2 * -1
    );

    const max2D = Math.ceil(Math.max(size.x /2 , size.z /2 ));
    const maxY = Math.ceil(size.y) > max2D ? Math.ceil(size.y) : max2D;

    if(axesRef.current){
      axesRef.current.scale.set(max2D, maxY, max2D);
      axesRef.current.position.set(0, basePoint.y, 0);
    }

    if(gridRef.current){
      // gridRef.current.args={[5,5]};
      gridRef.current.position.set(0, basePoint.y, 0);
      setGridArgs([max2D*2, max2D*2]);
    }

    setIsOnLoad(true);
  }
  return (
    <>
      { !isOnLoad &&
        <Box display="flex" justifyContent="center" alignItems="center"
          width="100%" height="100%" sx={{position:"absolute",top:0,left:0,backgroundColor:"rgba(255, 255, 255, .6)"}}>
          <CircularProgress size="25px" sx={{color:"gray"}} />
        </Box>
      }
      <span style={{ visibility: isOnLoad ? "visible" : "hidden" }}>
        <Canvas shadows={{ type: 2 }} camera={{ position: [-1, 1, 1], fov: 75 }}
          onPointerMove={handlePointerMove} onPointerUp={handlePointerUp} onPointerEnter={handlePointerEnter} onPointerLeave={handlePointerLeave}>

          {/* 環境設定 */}
          <ambientLight intensity={0.5} />
          <directionalLight position={[5, 5, 5]} castShadow />

          {/* Helper */}
          <Grid ref={gridRef} args={gridArgs} sectionSize={1} sectionColor="rgb(224, 224, 224)" cellSize={0.1} cellColor="rgb(200, 200, 200)"/>
          <axesHelper ref={axesRef} scale={[5, 5, 5]} position={[0, 0, 0]} />

          {/* URDFモデル */}
          <Suspense fallback={null}>
            <Bounds fit clip>
              <URDFModel
                urdfUrl={props.urdfUrl}
                mesheUrls={props.mesheUrls}
                onLoadUrdf={onLoadUrdf}
                pointerDown={handlePointerDown}
              />
            </Bounds>
          </Suspense>

          {/* 操作用カメラコントロール */}
          <OrbitControls enableZoom={true} enabled={isMouseInside} ref={controlsRef} />
        </Canvas>

        <Box display="flex" sx={{position:"absolute",top:"-14px",right:"3px"}}>
          <Pjdb1ToolTip toolTip={
            <span>
              スクロール：拡大/縮小<br />
              (左クリック)ドラッグ：回転<br />
              (右クリック)ドラッグ：移動<br />
              可動部を選択してマウス移動：可動部を動かす
            </span>
          } />
        </Box>
      </span>
    </>
  );

});

